<template>
  <div class="upload">
    <el-upload :disabled='disabled' class="upload-demo" ref="uploading" :action="require('@/config/enum').actionname"
      :on-preview="handlePreview" :on-remove="handleRemove" :before-remove="beforeRemove" :on-change="handleSuccess"
      :on-error="uploadErr" :on-exceed="uploadExceed" :accept="accept" :file-list="fileList" :limit="999" name="files"
      :multiple="true" :auto-upload="false" list-type="picture">
      <el-button style="margin-right:20px;" slot="trigger" size="small" type="primary">{{$t('lang.btn_selectfile')}}
      </el-button>
      <!-- <br/> -->
      <!-- <div class="el-upload__tip" v-if="upTypes==='1'" slot="tip">{{$t('lang.picture_tips')}}</div> -->
      <!-- <div class="el-upload__tip" v-if="upTypes==='2'" slot="tip">{{$t('lang.lab_please_Upload')+$t('lang.lab_taskEditFileUpload')}}</div> -->
      <el-button class="ma-top" size="small" type="success" @click="submitUpload">{{$t('lang.btn_uploadtoserver')}}
      </el-button>
      <span style="margin-left: 20px;color:#3A8DFC;">
        <i class="el-icon-warning"></i>
        点击已上传文件的名称即可下载文件</span>
    </el-upload>
  </div>
</template>

<script>
  export default {
    props: ['clears', 'fileList', 'disabled', 'upTypes', 'accept'],
    data() {
      return {}
    },
    watch: {
      // 点击清空
      clears() {
        if (this.clears) {
          this.$emit('removeFile', true)
        }
      }
    },
    methods: {
      // 上传到服务器
      submitUpload() {
        this.$refs.uploading.submit()
      },
      // 上传成功
      handleSuccess(file) {
        if (file && file.response) {
          this.$emit('outputFile', file.response.data[0], file.name)
        }
      },
      // 删除
      handleRemove(file) {
        if (file) {
          if (file.response && file.response.data[0]) {
            this.$emit('removeFile', file.response.data[0])
          } else {
            this.$emit('removeFile', file.url)
          }
        }
      },
      // 删除提示
      beforeRemove(file, fileList) {
        return this.$confirm(`确定移除 ${file.name}？`)
      },
      // 超出上传个数
      uploadExceed(files, fileList) {
        this.$message.warning(this.$i18n.t('lang.lab_uploadWarning9'))
      },
      // 断网
      uploadErr() {
        if (!navigator.onLine || window.navigator.onLine === false) {
          const loading = this.$loading()
          setTimeout(() => {
            loading.close()
            this.$message.error(this.$i18n.t('lang.lab_Online'))
          }, 500)
        }
      },
      handlePreview(file) {
        console.log(file)
        var url = 'http://' + window.location.host + '/mapi/'
        if (file.response) {
          window.open(url + `downloadFileByRealName?downloadUrl=` + file.response.data[0] + `&realFileName=` + file
            .name)
        } else {
          if (file.url.indexOf('blob:') == -1) {
            window.open(url + `downloadFileByRealName?downloadUrl=` + file.url + `&realFileName=` + file
              .name)
          }
        }
      }
    }
  }
</script>
<style lang='scss'>
  .upload .ma-top {
    margin-top: 8px;
  }

  .upload .el-form-item__content {
    line-height: 10px !important;
  }
</style>